import "../assets/Back.css";
import { defineComponent as r, useCssVars as _, computed as l, ref as g, watch as f, openBlock as c, createElementBlock as s, createElementVNode as m, createCommentVNode as k } from "vue";
import { n as p } from "./useStore.CDG6wbfK.js";
const v = { class: "thn--tool-back" }, h = ["image-loaded"], b = ["alt", "src"], I = /* @__PURE__ */ r({
  __name: "Back",
  setup(B) {
    _((t) => ({
      "3a295ff2": d.value
    }));
    const e = p(), d = l(() => e != null && e.rtl ? "scaleX(-1)" : "none"), o = g(!1), n = l(() => e == null ? void 0 : e.styles.backgroundImage), u = l(() => e == null ? void 0 : e.styles.backgroundImageAlt);
    function i() {
      o.value = !0;
    }
    return f(() => e == null ? void 0 : e.styles.backgroundImage, (t, a) => {
      a !== t && (o.value = !1);
    }), (t, a) => (c(), s("div", v, [
      a[0] || (a[0] = m("div", { class: "thn--tool-back__color" }, null, -1)),
      n.value ? (c(), s("div", {
        key: 0,
        "image-loaded": o.value,
        class: "thn--tool-back__image"
      }, [
        m("img", {
          onLoad: i,
          alt: u.value,
          src: n.value
        }, null, 40, b)
      ], 8, h)) : k("", !0)
    ]));
  }
});
export {
  I as _
};
//# sourceMappingURL=Back.vue_vue_type_style_index_0_lang.D3HVPbBh.js.map
